import React from 'react';
import { Link } from '@mui/material';

interface ActionLinkProps {
  label: string;
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * Standardized action link component for appointment card actions
 * Handles click event propagation and consistent styling
 */
export const ActionLink: React.FC<ActionLinkProps> = ({ label, onClick }) => (
  <Link
    component="button"
    variant="body2"
    underline="hover"
    sx={{ cursor: 'pointer' }}
    onClick={e => {
      e.stopPropagation();
      onClick?.(e);
    }}
  >
    {label}
  </Link>
);